export default __webpack_public_path__ + "static/media/524.e14973e4.png";